/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

import { loc } from "../../../core/utils";
import * as yup from "yup";

const requiredMessage = () => loc`Required`;


const schema = yup.object().shape({
  identity: yup.object().shape({
    title: yup.string().nullable().required(requiredMessage)
  })
});

export default schema
